class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );
    window.addEventListener("popstate", this.onHistoryChange.bind(this));

    this.bindActiveFacetButtonEvents();

    this.checkAbsentImages();
  }

  checkAbsentImages() {
    const imgs = this.querySelectorAll(".js-filter img");

    imgs.forEach((img) => {
      img.addEventListener("error", () => {
        img.remove();
      });
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    // this.toggleActiveFacets();
    this.renderPage(new URL(event.target.href).searchParams.toString());
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || "";
    this.renderPage(searchParams);
  }
  renderPage(searchParams) {
    triggerEvent(this, "filters:filter-changed", {
      searchParams: searchParams.toString(),
    });
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#CollectionFiltersForm .js-filter, #CollectionFiltersFormMobile .js-filter"
    );
    const matchesIndex = (element) =>
      element.dataset.index ===
      event?.target.closest(".js-filter")?.dataset.index;
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    this.renderActiveFacets(parsedHTML);

    if (countsToRender)
      this.renderCounts(countsToRender, event.target.closest(".js-filter"));
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    this.bindActiveFacetButtonEvents();
    this.toggleActiveFacets(false);
  }

  renderMobileElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
    ];

    mobileElementSelectors.forEach((selector) => {
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("CollectionFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  renderCounts(source, target) {
    const countElementSelectors = [".count-bubble", ".facets__selected"];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML =
          source.querySelector(selector).outerHTML;
      }
    });
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.addEventListener("click", this.onActiveFilterClick, {
        once: true,
      });
    });
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }
}

customElements.define("collection-filters", CollectionFilters);

class PriceRangeSlider extends HTMLElement {
  static observedAttributes = ["data-min-limit", "data-max-limit"];

  constructor() {
    super();
    this.minInput = this.querySelector('input[name$="gte"]');
    this.maxInput = this.querySelector('input[name$="lte"]');
  }

  connectedCallback() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.init();
          observer.disconnect();
        }
      });
    });
    observer.observe(this);
  }

  init() {
    this.getValues();
    this.initSlider();
    this.initDragFunctionality();
    this.afterInit();
    this.updateOnInputChange();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (!this.isSource) return;
    if (!oldValue) return;
    if (name === "data-min-limit" || name === "data-max-limit") {
      this.getValues();
      this.minInput.dispatchEvent(new Event("change"));
      this.maxInput.dispatchEvent(new Event("change"));
    }
  }

  afterInit() {
    this.updateKnobValues();
    this.updateInputValues();
  }

  getValues() {
    this.minLimit = parseInt(this.dataset.minLimit) || 0;
    this.maxLimit = parseInt(this.dataset.maxLimit) || 1000;

    this.minLimit =
      this.minLimit > this.maxLimit ? this.maxLimit : this.minLimit;
    this.maxLimit =
      this.maxLimit < this.minLimit ? this.minLimit : this.maxLimit;
  }

  initSlider() {
    /**
     * We render the slider using JS to avoid manual work.
     * This function creates the slider elements and appends them to the DOM.
     */
    const sliderContainer = document.createElement("div");
    sliderContainer.className = "relative w-full h-10";

    const knobClass =
      "absolute w-4 h-4 border bg-background1 border-outline shadow active:border-10 top-1/2 -translate-y-1/2 rounded-full cursor-pointer after:absolute after:bottom-full after:left-1/2 after:-translate-x-1/2 after:pb-2 after:text-sm before:absolute before:w-12 before:h-12 before:left-1/2 before:top-1/2 before:-translate-y-1/2 before:-translate-x-1/2";

    const minKnob = document.createElement("div");
    minKnob.className = knobClass + " after:content-[attr(data-value)]";
    minKnob.style.left = this.calculateKnobPosition(this.minInput.value) + "%";
    this.minKnob = minKnob;

    const maxKnob = document.createElement("div");
    maxKnob.className = knobClass + " after:content-[attr(data-value)]";
    maxKnob.style.right =
      100 - this.calculateKnobPosition(this.maxInput.value) + "%";
    this.maxKnob = maxKnob;

    const line = document.createElement("div");
    line.className =
      "absolute w-full h-0.5 bg-outline/25 top-1/2 transform -translate-y-1/2";

    const activeLine = document.createElement("div");
    activeLine.className =
      "absolute h-1 bg-outline top-1/2 transform -translate-y-1/2";
    this.activeLine = activeLine;

    sliderContainer.append(line, activeLine, minKnob, maxKnob);
    this.append(sliderContainer);

    // we need to get the rect of the slider container to calculate the knob position later
    this.rect = sliderContainer.getBoundingClientRect();
  }

  initDragFunctionality() {
    // adds event listeners to the slider elements for drag functionality
    this.isDragging = false;
    this.currentKnob = null;

    this.minKnob.addEventListener("mousedown", (e) =>
      this.startDrag(e, this.minKnob)
    );
    this.maxKnob.addEventListener("mousedown", (e) =>
      this.startDrag(e, this.maxKnob)
    );

    this.minKnob.addEventListener("touchstart", (e) =>
      this.startDrag(e, this.minKnob)
    );

    this.maxKnob.addEventListener("touchstart", (e) =>
      this.startDrag(e, this.maxKnob)
    );
    this.minKnob.addEventListener("mousemove", this.doDrag.bind(this));
    this.maxKnob.addEventListener("mousemove", this.doDrag.bind(this));
    this.minKnob.addEventListener("touchmove", this.doDrag.bind(this));
    this.maxKnob.addEventListener("touchmove", this.doDrag.bind(this));
    this.minKnob.addEventListener("touchend", this.endDrag.bind(this));
    this.maxKnob.addEventListener("touchend", this.endDrag.bind(this));
    this.minKnob.addEventListener("mouseup", this.endDrag.bind(this));
    this.maxKnob.addEventListener("mouseup", this.endDrag.bind(this));
  }

  startDrag(e, knob) {
    // sets the current knob and starts the drag
    e.preventDefault();
    this.isDragging = true;
    this.currentKnob = knob;
    this.maxKnob.addEventListener("mouseout", this.onMouseOut.bind(this), {once: true});
    this.minKnob.addEventListener("mouseout", this.onMouseOut.bind(this), {once: true});
  }

  doDrag(e) {
    // if we are not dragging, we don't need to do anything
    if (!this.isDragging) return;

    let clientX = e.clientX || e.touches[0].clientX;

    // calculates the new left percentage of the knob
    let newLeft = Math.max(
      0,
      Math.min(
        this.rect.width,
        clientX - this.rect.left - this.currentKnob.offsetWidth / 2
      )
    );
    let newRight = Math.max(
      0,
      Math.min(
        this.rect.width,
        this.rect.width -
          (clientX - this.rect.left) -
          this.currentKnob.offsetWidth / 2
      )
    );

    // if the new left position is out of bounds, we set it to the min or max value
    if (
      this.currentKnob === this.minKnob &&
      newLeft > parseInt(this.maxKnob.offsetLeft)
    ) {
      newLeft = parseInt(this.maxKnob.offsetLeft);
    } else if (
      this.currentKnob === this.maxKnob &&
      newLeft < parseInt(this.minKnob.offsetLeft)
    ) {
      newRight = parseInt(this.minKnob.offsetRight);
    }

    // we set the new left position of the knob
    if (this.currentKnob === this.minKnob) {
      this.currentKnob.style.left = newLeft + "px";
    } else {
      this.currentKnob.style.right = newRight + "px";
    }

    this.updateKnobValues();
  }

  onMouseOut() {
    this.isDragging && this.endDrag()
  }

  endDrag() {
    // sets the isDragging to false and currentKnob to null
    this.isDragging = false;
    this.currentKnob = null;

    // if not using the apply button, do the deed on drag end
    debounce(this.updateInputValues(), 1000);
    debounce(this.syncWithOtherRangeSliders(), 1000);
    debounce(this.closest("form").dispatchEvent(new Event("input")), 1000);
    setTimeout(() => {
      this.updateInputValues();
      this.syncWithOtherRangeSliders();
    }, 1000);
  }

  updateActiveLine() {
    // updates the active line in between the knobs
    this.activeLine.style.left =
      parseInt(this.minKnob.offsetLeft) + this.minKnob.offsetWidth / 2 + "px";
    this.activeLine.style.right =
      parseInt(this.rect.width) -
      parseInt(this.maxKnob.offsetLeft) -
      this.maxKnob.offsetWidth / 2 +
      "px";
  }

  getKnobMoneyValue(knob) {
    // returns the money value of the knob without the currency symbol
    let percentage =
      knob === this.minKnob
        ? parseInt(knob.offsetLeft) / this.rect.width
        : (parseInt(knob.offsetLeft) + knob.offsetWidth) / this.rect.width;
    let value = Math.round(
      this.minLimit + (this.maxLimit - this.minLimit) * percentage
    );
    if (this.rect.width === 0) {
      percentage = 0;
      value = 0;
    }
    return value;
  }

  updateKnobValues() {
    // updates the visible values on the knobs
    this.minKnob.dataset.value = "$" + this.getKnobMoneyValue(this.minKnob);
    this.maxKnob.dataset.value = "$" + this.getKnobMoneyValue(this.maxKnob);

    this.updateActiveLine();
    if (this.closest("form").dataset.isApplyActive === "true") {
      this.updateApplyButton();
    }
  }

  updateApplyButton() {
    const filter = this.closest(".js-filter");
    if (!filter) return;
    const clearApplyButtons = filter.querySelectorAll(".js-filter-apply");
    if (this.isKnobsReset()) {
      clearApplyButtons.forEach((button) => (button.disabled = true));
      const remover = document.querySelector("#price-range-remove a");
      if (!remover) return;
      remover.click();
    } else {
      clearApplyButtons.forEach((button) => (button.disabled = false));
    }
  }

  isKnobsReset() {
    return (
      this.minKnob.offsetLeft === 0 &&
      this.maxKnob.offsetLeft === this.rect.width - this.maxKnob.offsetWidth
    );
  }

  updateInputValues() {
    this.minInput.value = this.getKnobMoneyValue(this.minKnob);
    this.maxInput.value = this.getKnobMoneyValue(this.maxKnob);

    if (this.minInput.value === "0") this.minInput.value = "";
    if (parseInt(this.maxInput.value) === this.maxLimit)
      this.maxInput.value = "";
  }

  updateOnInputChange() {
    const onInputChange = (e, knob) => {
      let newValue = parseInt(e.target.value);

      // control min/max limits
      if (newValue > this.maxLimit) {
        newValue = this.maxLimit;
        e.target.value = newValue;
      } else if (newValue < this.minLimit) {
        newValue = this.minLimit;
        e.target.value = newValue;
      }

      // control min/max to not overlap
      if (knob === this.minKnob && newValue > this.maxInput.value) {
        newValue =
          newValue > this.maxLimit ? this.maxLimit : this.maxInput.value;
        e.target.value = newValue;
      } else if (knob === this.maxKnob && newValue < this.minInput.value) {
        newValue = this.minInput.value;
        e.target.value = newValue;
      }

      if (knob === this.minKnob)
        knob.style.left = this.calculateKnobPosition(newValue) + "%";
      if (knob === this.maxKnob)
        knob.style.right = 100 - this.calculateKnobPosition(newValue) + "%";
      this.updateKnobValues();
    };

    const debouncedOnInputChange = debounce(onInputChange, 750);

    this.minInput.addEventListener("input", (e) =>
      debouncedOnInputChange(e, this.minKnob)
    );
    this.maxInput.addEventListener("input", (e) =>
      debouncedOnInputChange(e, this.maxKnob)
    );
    this.minInput.addEventListener("change", (e) =>
      onInputChange(e, this.minKnob)
    );
    this.maxInput.addEventListener("change", (e) =>
      onInputChange(e, this.maxKnob)
    );
  }

  reset() {
    this.minInput.removeAttribute("value");
    this.maxInput.removeAttribute("value");
    this.minKnob.style.left = "0%";
    this.maxKnob.style.right = "0%";
    this.updateKnobValues();
  }

  syncWithOtherRangeSliders() {
    // find all range sliders and filter this one out using filter()
    const otherRangeSliders = [
      ...document.querySelectorAll("price-range-slider"),
    ].filter((slider) => slider !== this);

    // loop through the other range sliders and update the min and max values
    // otherRangeSliders.forEach((slider) => {
    //   slider.minInput.value = this.minInput.value;
    //   slider.maxInput.value = this.maxInput.value;
    // });
  }

  updateKnobByInput(e, knob) {}

  calculateKnobPosition(value) {
    const percentage =
      ((value - this.minLimit) / (this.maxLimit - this.minLimit)) * 100;
    return percentage;
  }
}
window.customElements.define("price-range-slider", PriceRangeSlider);

